import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';

let initiated = false;
let openedMatchPage = false;
let nextDayInFutureLoaded = 0;

const LIVE_INTERVAL = 60 * 1000; // 1 minute
const DEFAULT_INTERVAL = 20 * 60 * 1000; // 20 minutes

function canMakeRequest(requestKey, interval) {
  const store = getStore('match');
  const lastTimestamp = store.getLastRequestTimestamp(requestKey);
  const now = Date.now();
  return now - lastTimestamp >= interval;
}

const INITIAL_FETCH_DELAY = 1000;

bus.on(constants.EVENTS.APP.READY, () => {
  if (initiated) return;
  initiated = true;
  setTimeout(() => {
    getUpcommingMatches();
  }, INITIAL_FETCH_DELAY);
});

bus.on(constants.EVENTS.MATCH.LIST_ALL.REFRESHED, ({ isDataRefresh }) => {
  if (isDataRefresh) return;
  if (!openedMatchPage && nextDayInFutureLoaded == 4) return;
  if (nextDayInFutureLoaded >= 18) return;
  getUpcommingMatches();
});

async function getUpcommingMatches(
  dayInFuture = nextDayInFutureLoaded,
  isDataRefresh
) {
  console.log("🚀 ~ getUpcommingMatches ~ dayInFuture:", dayInFuture)
  const requestId = `listAllAds-${Date.now()}`;
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.MATCH.GET_LIST}${dayInFuture}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res, dayInFuture);
      if (parsed.success) {
        if (!isDataRefresh) nextDayInFutureLoaded++;
        bus.emit(constants.EVENTS.MATCH.LIST_ALL.REFRESHED, {
          data: parsed.data,
          isDataRefresh
        });
      } else {
        bus.emit(constants.EVENTS.MATCH.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
}

bus.on(constants.EVENTS.MATCH.LIST_ALL.REFRESH, () => {
  if(openedMatchPage) return
  openedMatchPage = true;
  // if (!canMakeRequest('list_all_refresh', DEFAULT_INTERVAL)) {
  //   return;
  // }
  const store = getStore('match');
  console.log("🚀 ~ store:", store)
  store.setLastRequestTimestamp('list_all_refresh');
  bus.emit(constants.EVENTS.MATCH.LIST_ALL.REFRESHING);
  // getUpcommingMatches(0, true);
  getUpcommingMatches();
});

bus.on(constants.EVENTS.MATCH.LIVE.REFRESH, () => {
  if (!canMakeRequest('live_refresh', LIVE_INTERVAL)) {
    return;
  }
  const store = getStore('match');
  store.setLastRequestTimestamp('live_refresh');
  const requestId = `live-${Date.now()}`;
  bus.emit(constants.EVENTS.MATCH.LIVE.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.MATCH.GET_LIVE}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.MATCH.LIVE.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.MATCH.LIVE.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.MATCH.PRONOSTICS.REFRESH, () => {
  if (!canMakeRequest('pronostics_refresh', DEFAULT_INTERVAL)) {
    return;
  }
  const store = getStore('match');
  store.setLastRequestTimestamp('pronostics_refresh');
  const requestId = `pronostics-${Date.now()}`;
  bus.emit(constants.EVENTS.MATCH.PRONOSTICS.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.MATCH.GET_PRONOSTICS}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.MATCH.PRONOSTICS.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.MATCH.PRONOSTICS.REFRESH_ERROR, parsed);
      }
    }
  });
});
